<form [formGroup]="ruleListSubHeaderForm">
  <div class="expanded-row-filter sdps-p-bottom_medium">
    <div *ngFor="let col of filteredRequest; let i = index;">
      <!-- Header section of the rule sub-header -->
      <div class="sdps-p-left_small sdps-p-bottom_small sdps-p-top_small">
        <span *ngIf="col.header !== 'Group Name' && col.header !== 'Rule Level' && col.header !== 'Show Records' && col.header !== 'Instrument Group'">{{col.header}}</span>
        <span *ngIf="this.businessUnit !== '' && col.header === 'Group Name'">{{sharedConstant[businessUnit] ? sharedConstant[businessUnit].enterGroupOrPlanName : sharedConstant['RBS'].enterGroupOrPlanName}}</span>
        <span  *ngIf="this.businessUnit !== '' && col.header === 'Instrument Group' && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.instrumentsSummary.uuid,'','')">
          {{col.header}}
        </span>
        <span  *ngIf="col.header === 'Rule Level'&& sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.globalRuleSummary.uuid,'','')">
          {{col.header}}
        </span>
        <span  *ngIf="col.header === 'Show Records'">
          {{col.header}}
        </span>
      </div>

        <!-- Symbol and CUSIP -->
        <div class="sdps-p-left_small sdps-m-right_none" *ngIf="col.enum === 'textbox'">
          <input pInputText [attr.aria-label]="col.header + ' filter'" id="rule_{{col.field}}" formControlName="{{col.field}}" class="w-95-per" type="text" name="{{col.field}}" emsAlphaNumericSpecialCharacterValidation emsStartSpaceValidator
                 [ngClass]="{'w-65-per' : col.field === 'cusipSymbol','invalidField': col.field === 'cusipSymbol' ? filterBtnDisableForCusip || (ruleListSubHeaderForm.get('cusipSymbol').value && ruleListSubHeaderForm.get('cusipSymbol').invalid) : filterBtnDisableForTradeSymbol || (ruleListSubHeaderForm.get('tradeSymbol').value && ruleListSubHeaderForm.get('tradeSymbol').invalid)}"
          (keydown.enter)="!(this.ruleListSubHeaderForm.invalid || filterBtnDisableForCusip || invalidRuleNameField)? enterFilterValue() : ''" onkeydown="return (event.keyCode !== 13)"
          [maxlength]="col.field === 'cusipSymbol' ? '9' : ''">
        </div>

        <!-- Group/Plan Name -->
        <div class="timePickerForm emtr-dropdown sdps-p-left_small sdps-p-right_small group-plan-name-dropdown" *ngIf="col.enum === 'dropdown' && col.field === 'empGroupName' && this.businessUnit !== ''">
          <ems-lazy-load-dropdown [id]="'rule_' + col.field" [name]="col.field" [orgID]="orgID" [dropdownName]="'groupName'"
            [businessUnit]="businessUnit" [ariaLabel]="col.header + ' filter'" (ngModelGroupChange)="groupNameUpdated($event)"
            (updateGroupOrPlanName)="updateGroupOrPlanName()"></ems-lazy-load-dropdown>
        </div>

      <!-- Instrument Group -->
      <div class="timePickerForm emtr-dropdown sdps-p-left_small sdps-p-right_small instrument-group-name-dropdown" *ngIf="col.enum === 'dropdown' && col.header === 'Instrument Group' && this.businessUnit !== ''">
          <ems-lazy-load-dropdown [id]="'rule_' + col.field" [name]="col.field" [orgID]="orgID"
            [dropdownName]="'instrumentGroup'" [businessUnit]="businessUnit" [ariaLabel]="col.header + ' filter'"
            (ngModelGroupChange)="instrumentGroupNameUpdated($event)"></ems-lazy-load-dropdown>
      </div>


        <!-- Rule Level multiselect -->
        <div class="emtr-dropdown timePickerForm request-list-filter request-list-multiselect-font-size request-list-filter-multiselect sdps-p-left_small sdps-p-right_small" *ngIf="col.field === 'ruleLevel' && col.enum === 'multiselect' && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.globalRuleSummary.uuid,'','')">
          <p-multiSelect id="rule_{{col.field}}" [ariaLabel]="col.header + ' filter'" appendTo="body" formControlName="{{col.field}}" [options]="emtrConstant.ruleFilter.ruleLevel"
                             [filter]="true" [defaultLabel]="' '" [displaySelectedLabel]="true" [maxSelectedLabels]="1" [optionDisabled]="this.businessUnit === '' ? isOptionDisabled : false"
                             [showHeader]="true" [filterPlaceHolder]="'All'" [showToggleAll]="false">
      </p-multiSelect>
        </div>

      <!-- Show Records dropdown -->
      <div class="timePickerForm emtr-dropdown sdps-p-left_small sdps-p-right_small show-records"*ngIf="col.field === 'showRecords' && col.enum === 'dropdown'">
        <p-select id="rule_{{col.field}}" [ariaLabel]="'Records per page'" appendTo="body" optionLabel="label" formControlName="{{col.field}}"
                    [options]="emtrConstant.showRecords">
        </p-select>
      </div>
    </div>
  </div>
</form>
